var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"icon unex",class:[("unex-icon-" + _vm.svg), _vm.className],style:(_vm.style),on:{"click":function($event){_vm.handleClick()}}})}
var staticRenderFns = []

export { render, staticRenderFns }